<template>
  <div class='flex gap-2 items-center'>
    <label class='flex-1'>
      <span class="block text-sm font-medium leading-6 text-gray-900 mb-2" :class='{"sr-only": props.hideLabel}'>
        {{ props.label }} <span class='sr-only'>From</span>
      </span>
      <input type="text" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-jananavy-600 sm:text-sm sm:leading-6" ref='fromElement' placeholder='From' />
    </label>
    <label class='flex-1'>
      <span class="block text-sm font-medium leading-6 text-gray-900 mb-2 opacity-0" :class='{"sr-only": props.hideLabel}'>
        {{ props.label }} <span class='sr-only'>To</span>
      </span>
      <input type="text" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-jananavy-600 sm:text-sm sm:leading-6" ref='toElement' placeholder='To' />
    </label>
  </div>
</template>

<script setup>

import { ref, reactive, watch, onMounted } from 'vue';

import "../../../node_modules/vanillajs-datepicker/dist/css/datepicker.min.css";
import { Datepicker } from 'vanillajs-datepicker';

import enAU from 'vanillajs-datepicker/locales/en-AU';

Object.assign(Datepicker.locales, enAU);

const props = defineProps({
  label: String,
  hideLabel: Boolean
});

const fromElement = ref();
const toElement = ref();

let fromInstance = null;
let toInstance = null;

const model = defineModel();

watch(model, () => {
  modelDidChange();
});

const modelDidChange = () => {
  if (!fromInstance || !toInstance) {
    return;
  }
  
  const fromDate = fromInstance.getDate();
  const toDate = toInstance.getDate();
  
  if (fromDate !== model.value?.from) {
    fromInstance.setDate(model.value.from);
  }
  
  if (toDate !== model.value?.to) {
    toInstance.setDate(model.value.to);
  }
}

const didChangeDate = () => {
  const fromDate = fromInstance.getDate() || null;
  const toDate = toInstance.getDate() || null;
  
  if (model.value?.from !== fromDate || model.value?.to !== toDate) {
    if (!fromDate && !toDate) {
      model.value = null;
    } else {
      model.value = {
        from: fromDate,
        to: toDate
      }
    }
  }
}

onMounted(() => {
  const config = {
    language: Intl.DateTimeFormat().resolvedOptions().locale,
    clearButton: true,
    autohide: true
  };
  
  if (!fromInstance) {
    fromInstance = new Datepicker(fromElement.value, config);
    
    if (model.value?.from) {
      fromInstance.setDate(model.value.from);
    }
    
    fromElement.value.addEventListener('changeDate', () => {
      didChangeDate();
    });
  }
  
  if (!toInstance) {
    toInstance = new Datepicker(toElement.value, config);
    
    if (model.value?.to) {
      toInstance.setDate(model.value.to);
    }
    
    toElement.value.addEventListener('changeDate', () => {
      didChangeDate();
    });
  }
});

</script>